import { Spade, Coins, Wine, MapPin } from 'lucide-react';
import { makeServicePage } from '../components/ServicePageTemplate';

const page = {
  seo: {
    path: '/poker-packages',
    title: 'Poker Packages Melbourne | Topless Poker Dealers & Poker Nights | Topless Waitressing Melbourne',
    description: 'Poker packages in Melbourne with topless and lingerie poker dealers, poker tables and chips for bucks nights, birthdays and private poker nights. Get a quote today.',
  },
  hero: {
    badge: 'Poker Nights',
    h1: 'Poker Packages',
    h1Accent: 'Melbourne',
    intro: 'Topless and lingerie poker dealers, tables and chips for a casino-style poker night at home, perfect for bucks parties, birthdays and private events.',
    highlight: "Melbourne's most reviewed topless poker dealers",
    image: '/images/models/roxy/Roxy1.webp',
    bannerImage: '/images/backgrounds/poker-hero.webp',
  },
  highlights: [
    { icon: Spade, title: 'Topless Poker Dealers', text: 'Dealers who run the table, manage the pot and keep the banter flowing.' },
    { icon: Coins, title: 'Table, Chips & Cards', text: 'Packages can include the full poker setup so you just bring the players.' },
    { icon: Wine, title: 'Add Topless Waitresses', text: 'Keep the drinks coming without anyone leaving the game.' },
    { icon: MapPin, title: 'Melbourne & Regional VIC', text: 'CBD, suburbs, Geelong, Mornington Peninsula and regional Victoria.' },
  ],
  intro: { eyebrow: 'Poker Nights Melbourne', title: 'A Casino Night at Your Place' },
  models: { subtitle: 'Pick the dealer you want running your poker table.', offset: 10 },
  sections: [
    { p: [
      "A poker night is one of the easiest ways to get a group of mates together. Add a glamorous dealer who actually knows the game and you've got a night nobody will forget in a hurry.",
      'At Topless Waitressing Melbourne, we put together poker packages for private parties across Melbourne. Our dealers run the table, keep the game moving and make sure everyone is having a good time, whether your group are serious players or complete beginners.',
      "Let us know how many players you have and the kind of night you're planning, and we'll talk you through the packages available.",
    ] },
    { h2: 'Topless Poker Dealers', p: [
      'Our most popular option is a topless poker dealer. She deals the cards, manages the pot, explains the rules where needed and keeps the banter going around the table.',
      "It's a great way to keep the whole group involved, rather than having half the guests standing around waiting for something to happen.",
      'Prefer something a little more relaxed? Lingerie poker dealers are also available.',
    ] },
    { h2: "What's Included in a Poker Package?", p: [
      'Poker packages can include a dealer, a poker table, chips and cards, so you only need to supply the players and the drinks.',
      'Texas Hold\'em is the most common game, but if your group has another favourite, mention it when you enquire.',
      "Package inclusions can change, so ask our team for the current options and we'll confirm exactly what's included with your quote.",
    ] },
    { h2: 'Poker Nights for Bucks Parties', p: [
      'A poker night suits bucks parties where the group wants something social and competitive. It works well as the main event or as a warm-up before heading out.',
      'Many groups combine their poker package with topless waitresses to keep the drinks flowing, or finish the night with a private strip show.',
    ] },
    { h2: 'Birthday and Private Poker Nights', p: [
      'Poker packages are also booked for milestone birthdays, footy club functions, end-of-year parties and catch-ups with old mates.',
      "No experience needed. Our dealers are happy to teach first-timers, so nobody gets left out of the game.",
    ] },
    { h2: 'Combine Poker With Topless Waitresses', p: [
      "Having a dealer at the table and a topless waitress looking after drinks means nobody has to leave the game to grab a beer.",
      'It also helps keep the energy up between hands and gives guests who are sitting out a reason to stay involved.',
      'Ask us about combining poker, waitressing and show options for your event.',
    ] },
    { h2: 'Where Do We Run Poker Nights?', p: [
      'We cover the Melbourne CBD, inner and outer suburbs, Geelong, the Mornington Peninsula and regional Victoria.',
      "Most poker nights are held at private homes, but function rooms and holiday rentals work well too. You'll need enough room for the table and players, and permission from the venue for adult entertainment.",
      'No venue? Ask us about available venue hire arrangements.',
    ] },
    { h2: 'How Much Does a Poker Package Cost?', p: [
      'Pricing depends on the length of the game, the number of dealers and tables, the location and any extras you add.',
      "Send us your date, suburb, number of players and preferred dealer style, and we'll come back with a clear quote.",
    ] },
  ],
  faqs: [
    { q: 'Do your poker dealers know how to run a game?', a: 'Yes. Our dealers can run the table, manage the chips and explain the rules for anyone who is new to poker.' },
    { q: 'Can I book a lingerie poker dealer instead of topless?', a: 'Yes. Both topless and lingerie poker dealers are available, subject to availability for your date.' },
    { q: 'Do you supply the poker table and chips?', a: 'Our poker packages can include a table, chips and cards. Ask us for the current inclusions when you enquire.' },
    { q: 'How many players can join?', a: 'Tell us your guest numbers and we will recommend the right number of tables and dealers for your group.' },
    { q: 'Can I add topless waitresses or a strip show?', a: 'Yes. Poker packages are often combined with topless waitressing or a private strip show.' },
    { q: 'Is real money gambling involved?', a: 'Our poker nights are for entertainment. Any arrangements between guests are up to your group and must comply with Victorian law.' },
  ],
  cta: {
    title: 'Book a Poker Package in Melbourne',
    text: "Shuffle up and deal. Tell us your date, venue and number of players and we'll put together the perfect poker night.",
  },
};

const PokerPackagesPage = makeServicePage(page);
export default PokerPackagesPage;
